import React from 'react';
import PropTypes from 'prop-types';
import PPITableRowColumnInput from './PPITableRowColumnInput';
import TableRow from 'material-ui/Table/TableRow';
import TableRowColumn from 'material-ui/Table/TableRowColumn';
import IconButton from 'material-ui/IconButton';
import IconDelete from 'material-ui/svg-icons/action/delete';

const tableRowColumnTitleStyle = {
    width: 220
};

const tableRowColumnDeleteStyle = {
    width: 64
};

const styles = {
    icon: {
        width: 24,
        height: 24
    },
    button: {
        width: 40,
        height: 40,
        marginLeft: '-20px',
        padding: 0
    }
};

class PPITableRow extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.labelId !== this.props.labelId;
    }

    render() {
        const { labelId, typePlayersList, deletePpiTableRow, ...otherProps } = this.props;
        const tableProps = { ...otherProps };
        Reflect.deleteProperty(tableProps, 'dispatch');

        return (
            <TableRow {...tableProps}>
                <TableRowColumn style={tableRowColumnTitleStyle}>{labelId}</TableRowColumn>
                {typePlayersList.map(typePlayer => (
                    <TableRowColumn key={typePlayer}>
                        <PPITableRowColumnInput typePlayer={typePlayer} label={labelId} />
                    </TableRowColumn>
                ))}
                <TableRowColumn style={tableRowColumnDeleteStyle}>
                    <IconButton
                        iconStyle={styles.icon}
                        style={styles.button}
                        onClick={() => deletePpiTableRow(labelId)}
                    >
                        <IconDelete />
                    </IconButton>
                </TableRowColumn>
            </TableRow>
        );
    }
}

PPITableRow.propTypes = {
    labelId: PropTypes.string.isRequired,
    typePlayersList: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    deletePpiTableRow: PropTypes.func.isRequired
};

export default PPITableRow;



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/components/PPITableRow.js
 **/